export const fmtSession = (s) => {
  if (!s?.date) return "";
  const d = new Date(`${s.date}T00:00:00`);
  const day = d.toLocaleDateString("en-AU", { weekday: "short", day: "numeric", month: "short" });
  return `${day} · ${s.start_time}${s.end_time ? `–${s.end_time}` : ""}`;
};

export const dayParts = (s) => {
  const d = new Date(`${s.date}T00:00:00`);
  return {
    wd: d.toLocaleDateString("en-AU", { weekday: "short" }),
    dd: d.getDate(),
    mm: d.toLocaleDateString("en-AU", { month: "short" }),
  };
};
